import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  CircularProgress,
  Container,
  Stack,
  Avatar,
} from '@mui/material';
import { Login as LoginIcon } from '@mui/icons-material';
import { useAuth } from '../hooks/useAuth';

const Login: React.FC = () => {
  const { login, isAuthenticated, isLoading, sessionStatus } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Only redirect to dashboard if user is authenticated AND authorized ('Allowed')
    if (!isLoading && isAuthenticated && sessionStatus === 'Allowed') {
      navigate('/', { replace: true });
    }
  }, [isAuthenticated, isLoading, sessionStatus, navigate]);

  // Show loading state while checking auth
  if (isLoading) {
    return (
      <Container maxWidth="sm">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
          }}
        >
          <CircularProgress size={60} />
          <Typography variant="h6" sx={{ mt: 2 }}>
            Loading...
          </Typography>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
        }}
      >
        <Card elevation={3} sx={{ width: '100%', maxWidth: 450 }}>
          <CardContent sx={{ p: 4 }}>
            <Stack spacing={3} alignItems="center">
              <Avatar
                sx={{
                  width: 80,
                  height: 80,
                  bgcolor: 'primary.main',
                }}
              >
                <LoginIcon sx={{ fontSize: 48 }} />
              </Avatar>

              <Box sx={{ textAlign: 'center' }}>
                <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
                  Welcome
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  Please sign in to continue to your dashboard
                </Typography>
              </Box>

              <Button
                variant="contained"
                size="large"
                fullWidth
                onClick={login}
                sx={{
                  py: 1.5,
                  textTransform: 'none',
                  fontSize: '1rem',
                }}
              >
                Sign In
              </Button>
            </Stack>
          </CardContent>
        </Card>

        <Typography variant="body2" color="text.secondary" sx={{ mt: 4, textAlign: 'center' }}>
          Myena HRMS © {new Date().getFullYear()}
        </Typography>
      </Box>
    </Container>
  );
};

export default Login;

